module.exports = __webpack_public_path__ + "img/组 4.c89a84a6.webp";